const useTypography = palette => {
  const text = palette?.text || {};

  const textGray = text?.textGray || 'gray';

  const typography = {
    fontFamily: 'Open Sans, sans-serif',
    button: { textTransform: 'none' },
    h4: {
      color: textGray,
      fontSize: '35px',
    },
    h5: {
      color: textGray,
      fontSize: '25px',
    },
    h6: {
      color: textGray,
      fontSize: '20px',
    },
    body1: {
      color: textGray,
      fontSize: '18px',
    },
    body2: {
      color: textGray,
      fontSize: '13px',
    },
    subtitle1: {
      color: text?.textSubtitle || '#000',
      fontSize: '16px',
    },
    subtitle2: {
      color: textGray,
      fontSize: '15px',
    },
  };

  return typography;
};

export default useTypography;
